import { HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import { jwtOptions } from '../jwt-utils';

export enum Environment {
  Prod = 'prod',
  Staging = 'staging',
  Test = 'test',
  Dev = 'dev',
  Local = 'local',
}

export interface Configuration {
  production: boolean;
  baseUrl: string;
  identityApiUrl: string;
  apiDomain: string;
  apiUrl: string;
  tokenKey: string;
  tokenExpKey: string;
  rfTokenKey: string;
  application: string;
  refreshListSecond: number;
  maxFileSize: number;
  maxSitePicture: number;
  pictureSiteType: string;
  versionApp: string;
}

@Injectable({ providedIn: 'root' })
export class EnvConfigurationService {

  get environment(): Configuration {
    return this._env;
  }


  private readonly configUrl = 'assets/config/config.json';
  private configuration$: Observable<Configuration>;
  private _env: Configuration;
  private httpClient: HttpClient;

  constructor(private http: HttpClient,
    handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  public async load() {
    let promise = new Promise((resolve, reject) => {
      let apiURL = `${this.configUrl}`;
      this.httpClient.get<Configuration>(apiURL)
        .toPromise()
        .then(
          res => { // Success
            this._env = res;
            jwtOptions.updateConfig(res);
            resolve(res);
          }
        );
    });
    return await promise;
  }
}